const Builder = require('./BuilderBase');
const HiddenFor = require('./HiddenFor');

module.exports = class DropDownSearch extends Builder {
    constructor(title, properties) {
        super('searchElement_DropDownSearch', title, properties);
        if (!properties.namespace || !properties.relation) {
            throw new Error('For DropDowns you must specify a namespace and a relation.');
        }
    }

    hiddenFor(role) {
        let hiddenFor = new HiddenFor(role);
        this.addChildBlock(hiddenFor, 'securityModifier');
        return this;
    }
};
